export default "__VITE_PUBLIC_ASSET__9202348a__"